import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { IndustryHierarchyItemBase } from './industry-hierarchy-item';

export class Business extends IndustryHierarchyItemBase implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Business';
  readonly apiRoute: string = CONFIG.apiRoutes.business;

  industryId: string;
  loadFromJson(data) {
  	super.loadFromJson(data);
    this.industryId = data.industryId;
  }
}
